AOS.init();

function truncateToDecimals(num, dec = 2) {
  const calcDec = Math.pow(10, dec);
  return Math.trunc(num * calcDec) / calcDec;
}

$(document).ready(function(){
  $('.announcement-close').click(function(){
    $('.announcement-bar-section').remove();
  })
  // $('.product-form__input label.variant-qty').on('click', function(){
  //   var qty = $(this).data('qty');
  //   var price = $(this).data('price');
  //   var currency = $(this).data('currency');
  //   var final = parseFloat(price) *qty;

  //   //console.log(final);
  //   $('.quantity__input').attr('value', qty.toString());
  //   $('.quantity__input').val(qty.toString());
  //   $('.product-current-price').text('£' + final.toFixed(2));
  // });

  $(document).on("change", ".appstle_subscription_radio_wrapper input", function(){
    var price = $(this).siblings().find('.appstle_subscription_amount').text();
    var number = Number(price.replace(/[^0-9\.-]+/g,""));
    var currency = price.replace(/[\d\., ]/g, '');

    var thestring = $('.product-form__input input[type=radio]:checked+label').text();
    var thenum = Number(thestring.replace(/\D/g, '')); 

    $('.cc__pricecostperitem').text("(" + currency + truncateToDecimals((number / thenum)) + " each" + ")");
  });

  $(document).on("change", ".appstle_one_time_details_wrapper input", function(){
    var price = $(this).siblings().find('.appstle_subscription_amount').text();
    var number = Number(price.replace(/[^0-9\.-]+/g,""));
    var currency = price.replace(/[\d\., ]/g, '');

    var thestring = $('.product-form__input input[type=radio]:checked+label').text();
    var thenum = Number(thestring.replace(/\D/g, '')); 

    $('.cc__pricecostperitem').text("(" + currency + truncateToDecimals((number / thenum)) + " each" + ")");
  });

  $('.recipe-blog-box:not(:nth-child(-n+3))').remove();

});

window.addEventListener('DOMContentLoaded', function(){
  function getUrlParameter(name) {
    name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  var variantParam = getUrlParameter("variant");

  if( variantParam ){
    var qty = document.querySelector(`[data-id="${variantParam}"]`).dataset.qty;
  }

});

